import {type IModuloScroll, ModuloScroll} from "../../../../root/modulo/scroll";
import {ESelector} from "../data/auxiliares";

export interface IModuloNoticiasUltimas extends IModuloScroll {
    selector: ESelector;
    promocionados: boolean;
}

export abstract class ModuloRedaccionUltimas extends ModuloScroll<IModuloNoticiasUltimas> {
    /* INSTANCE */
    protected constructor(cfg: IModuloNoticiasUltimas) {
        super({
            margen: "100px",
            visible: 0.0,
            ...cfg,
        });
    }
}
